import { Component, OnInit, TemplateRef } from '@angular/core';
import { ModalModule } from 'ngx-bootstrap/modal';
import { BsModalService } from 'ngx-bootstrap/modal';
import { BsModalRef } from 'ngx-bootstrap/modal/bs-modal-ref.service';

@Component({
  selector: 'app-popup-screen',
  templateUrl: './popup-screen.component.html',
  styleUrls: ['./popup-screen.component.css']
})
export class PopupScreenComponent implements OnInit {
  
  
  ngOnInit() {}

  modalRef: BsModalRef;
  constructor(private modalService: BsModalService) {}
 
  openModal(template: TemplateRef<any>) {
    this.modalRef = this.modalService.show(template);
  }

}



// WEBPACK FOOTER //
// /app/src/app/event/popup-screen/popup-screen.component.ts